import React, { useCallback, useContext, useState } from 'react';

import { GlobalContext } from '../../../../../store';
import { IAward } from '../../../../../store/admin/eventAwards/store';

import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useResultsSectionSelector } from '../../AssignRoundAwards/useResultsSectionSelector';
import OtherAwards from '../../Common/AssignAwardsTable/AssignAwardsTable';
import { useDisplayAwardsTable } from '../../Common/AssignAwardsTable/Hooks/useDisplayAwardsTable.hook';
import AssignResults from '../../Common/AssignResults/AssignResults';
import { AssignResultsSectionSelector } from '../../Common/AssignResultsSectionSelector/AssignResultsSectionSelector';
import { blankAward } from '../../Common/Utils/blankAward';

interface IAssignEventAwardsStep {
  awards: IAward[];
}

export const AssignEventAwardsStep = (props: IAssignEventAwardsStep) => {
  const { awards } = props;
  const { clubId, eventId } = useRouteInfoState();

  const {
    actions: {
      adminEventAwards: {
        create: createEventAwards,
        delete: deleteEventAwards,
        update: updateEventAwards
      }
    }
  } = useContext(GlobalContext);

  const [displayAwardsTable] = useDisplayAwardsTable();

  const deleteAwards = useCallback((awardId: number) => {
    deleteEventAwards(clubId, eventId, awardId);
  }, []);

  const createAwards = useCallback((award: IAward) => createEventAwards(clubId, eventId, award), [
    clubId,
    eventId
  ]);

  const updateAwards = useCallback(
    (awardId: number, award: IAward) => updateEventAwards(clubId, eventId, awardId, award),
    [clubId, eventId]
  );

  const [newAward, setNewAward] = useState(blankAward);

  const [sectionSelected, onSectionOnClick] = useResultsSectionSelector();

  return (
    <>
      <AssignResultsSectionSelector
        // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
        // otherAwardsOnClick={onSectionOnClick('OtherAwards')}
        leaderboardsOnClick={onSectionOnClick('Leaderboards')}
        sectionSelected={sectionSelected}
      />

      {sectionSelected === 'Leaderboards' ? (
        <AssignResults />
      ) : (
        <OtherAwards
          awards={awards}
          createAwards={createAwards}
          deleteAwards={deleteAwards}
          eventId={Number(eventId)}
          forceShowNewAwardRow={displayAwardsTable}
          newAward={newAward}
          setNewAward={setNewAward}
          updateAwards={updateAwards}
        />
      )}
    </>
  );
};
